import { BoolFilter } from "gen/search/service/service_pb"
import { Vendor } from "gen/vendors/models_pb"
import { useMemo } from "react"
import { UUID } from "shared-ts/classes/uuid"
import {
  Combobox,
  ComboboxProps,
} from "shared-web/components/base/input/Combobox"

import { useSearchVendors } from "features/api/search"

type VendorComboboxProps = Omit<
  ComboboxProps<Vendor>,
  "items" | "keyExtractor" | "valueExtractor" | "onChangeQuery"
>

export function VendorCombobox(props: VendorComboboxProps) {
  const { results: vendorSearchResults, setQuery: setVendorQuery } =
    useSearchVendors(
      { isActiveFilter: BoolFilter.TRUE },
      { ignoreSearchQuery: true }
    )

  const vendors = useMemo(
    () =>
      vendorSearchResults
        .map((result) => result.vendor)
        .filter((vendor): vendor is Vendor => !!vendor),
    [vendorSearchResults]
  )

  return (
    <Combobox<Vendor>
      items={vendors}
      onChangeQuery={setVendorQuery}
      keyExtractor={(vendor) => UUID.idString(vendor.id)}
      valueExtractor={(vendor) => vendor.name}
      {...props}
    />
  )
}
